import enumFactory from "@util/enumFactory";

export default enumFactory.createEnum({
    SYSTEM: {
        code: 1,
        title: '系统消息'
    },
    COUPON: {
        code: 2,
        title: '优惠券'
    },
    JOB: {
        code: 3,
        title: '工作通知'
    },

    getTitleByCode(code) {
        for(let key in this)
        {
            if (typeof(this[key]) === 'object' && this[key]['code'] === code)
            {
                return this[key]['title'];
            }
        }

        return '';
    }

});
